import { jsx as _jsx } from "react/jsx-runtime";
import { createBrowserRouter } from 'react-router-dom';
// Root Layout
import RootLayout from './RootLayout';
import RootErrorPage from './RootErrorPage';
// Auth Components
import { Logout } from '@containers/Auth/Logout';
import { Redirect } from '@containers/Auth/Redirect';
import { ExternalRedirect } from '@containers/Auth/ExternalRedirect';
import LoginContainer, { AuthRedirectLoadable } from '@containers/Auth/Loadable';
// Login Components
import Login from '@components/Login/Loadable';
import VerifyOtp from '@components/Login/VerifyOtp/Loadable';
// Feedback Components
import Feedback from '@containers/Feedback/Loadable';
import Thankyou from '@containers/Thankyou/Loadable';
// Assessment Components
import Assessment from '@containers/Assessment/Loadable';
import AssessmentError from '@containers/Assessment/AssessmentError/Loadable';
import AssessmentStatusError from '@containers/Assessment/AssessmentStatusError/Loadable';
import AssessmentSubmission from '@containers/Assessment/AssessmentSubmission/Loadable';
import AsyncPlayGround from '@containers/Assessment/AsyncPlayGround/Loadable';
import HardwareTest from '@containers/Assessment/HardwareTest/Loadable';
import Invite from '@containers/Assessment/Invite/Loadable';
import AssessmentSlotBooking from '@containers/Assessment/SlotBooking/Loadable';
import ObjectivePlayGround from '@containers/Assessment/ObjectivePlayGround/Loadable';
import PlayGround from '@containers/Assessment/PlayGround/Loadable';
import Submission from '@containers/Assessment/Submission/Loadable';
import Evaluation from '@containers/Assessment/Evaluation/Loadable';
import PlaylistObjectivePlayground from '@containers/Assessment/PlaylistObjectivePlayground/Loadable';
import NavigationGuidelinesController from '@containers/Assessment/NavigationGuideLines/Loadable';
// Candidate Registration Components
import RegisterCandidate from '@containers/CandidateRegistration/Loadable';
import RegistrationForm from '@containers/RegistrationForm/Loadable';
// Payment Components
import BookingConfirm from '@containers/Payment/BookingConfirm/Loadable';
import BookingReSchedule from '@containers/Payment/RescheduledBooking/Loadable';
import CancelBookingContainer from '@containers/Payment/CancelBooking/Loadable';
import PaymentLayout from '@containers/Payment/Loadable';
import PaymentSummary from '@containers/Payment/PaymentSummary/Loadable';
import SKUDetails from '@containers/Payment/SKUDetails/Loadable';
import PaymentInvoice from '@containers/Payment/PaymentInvoice/Loadable';
import PaymentCompletedCB from '@containers/Payment/CleverBridgePaymentCompleted/Loadable';
import StandAlonePayment from '@containers/Payment/StandAlonePayment/Loadable';
import PaymentFailed from '@containers/Payment/PaymentFailed/Loadable';
import TransactionReport from '@containers/Payment/TransactionReport/Loadable';
// Payment Error Screens
import BookingWindowCancelled from '@containers/Payment/ErrorScreens/BookingWindowCancelled/Loadable';
import BookingWindowClosed from '@containers/Payment/ErrorScreens/BookingWindowClosed/Loadable';
import CancellationWindowClosed from '@containers/Payment/ErrorScreens/CancellationWindowClosed/Loadable';
import RescheduleWindowClosed from '@containers/Payment/ErrorScreens/RescheduleWindowClosed/Loadable';
import SessionAlreadyCompleted from '@containers/Payment/ErrorScreens/SessionAlreadyCompleted/Loadable';
import BookingTimeUnavailable from '@containers/Payment/ErrorScreens/BookingTimeUnavailable/Loadable';
// Scheduling Components
import Scheduling from '@containers/Scheduling/Loadable';
import SlotBookingContainer from '@containers/Scheduling/SlotBooking/Loadable';
import ProposeNewTime from '@containers/Scheduling/ProposeNewTime/Loadable';
import AcceptProposedTimeContainer from '@containers/Scheduling/AcceptProposedTime/Loadable';
import ConfirmInterviewContainer from '@containers/Scheduling/ConfirmInterview/Loadable';
import InterviewDecline from '@containers/Scheduling/InterviewDecline/Loadable';
import JoinInterview from '@containers/Scheduling/JoinInterview/Loadable';
import DeclineProposedTimeContainer from '@containers/Scheduling/DeclineProposedTime/Loadable';
import RunningLate from '@containers/Scheduling/RunningLate/Loadable';
// Drive Components
import DriveCancelWindow from '@containers/Drive/DriveCancel/Loadable';
import DriveLayout from '@containers/Drive/Loadable';
import DriveSlotBookingContainer from '@containers/Drive/DriveScheduling/Loadable';
import DriveRegister from '@containers/Drive/Register/Loadable';
import DrivePostRegistrationForm from '@containers/Drive/Register/DrivePostRegistrationForm/Loadable';
// Consent Components
import ConsentContainer from '@containers/Consent/Loadable';
// Standalone Components
import Standalone from '@containers/Standalone/Loadable';
import StandaloneInstructions from '@containers/Standalone/StandaloneInstructions/Loadable';
import StandaloneSuccess from '@containers/Standalone/StandaloneSuccess/Loadable';
import StandaloneForm from '@containers/Standalone/StandaloneForm/Loadable';
// Lobby Components
import LobbyWaitingContainer from '@containers/Drive/Looby/LobbyWaiting/Loadable';
// FaceAuth
import FaceAuthContainer from '@containers/BiometricAuthentication/FaceAuth/Loadable';
import BiometricAuthentication from '@containers/BiometricAuthentication/Loadable';
// LongForm
import LongFormPlayground from '@containers/Assessment/LongFormPlayGround/Loadable';
import OldCxRouteMap from '@containers/OldCxRouteMap/Loadable';
import CertificationExam from '@containers/Scheduling/CertificationExam/Loadable';
// External
import ExternalPlayground from '@containers/Assessment/ExternalPlayground/Loadable';
import FormsPlayground from '@containers/Assessment/FormsPlayground/Loadable';
import CodingPlayground from '@containers/Assessment/CodingPlayground/Loadable';
import JobDescription from '@containers/JobDescription/Loadable';
import PublicAssessmentLoadable from '@containers/PublicAssessment/Loadable';
import CandidateAvailabilityContainer from '@containers/CandidateAvailability/Loadable';
import LanguageEvaluationSpeaking from '@containers/Assessment/LanguageEvaluationSpeaking/Loadable';
import CombinedEvaluation from '@containers/Assessment/CombinedEvaluation/Loadable';
const router = createBrowserRouter([
    {
        path: '/',
        element: _jsx(RootLayout, {}),
        errorElement: _jsx(RootErrorPage, {}),
        children: [
            {
                path: 'external-redirect',
                element: _jsx(ExternalRedirect, {}),
            },
            {
                lazy: LoginContainer,
                children: [
                    {
                        path: 'login',
                        lazy: Login,
                    },
                    {
                        path: 'verify',
                        lazy: VerifyOtp,
                    },
                ],
            },
            {
                lazy: AuthRedirectLoadable,
                children: [
                    {
                        path: 'redirect',
                        element: _jsx(Redirect, {}),
                    },
                    {
                        path: 'logout',
                        element: _jsx(Logout, {}),
                    },
                    {
                        path: 'registration-form',
                        lazy: RegistrationForm,
                    },
                    {
                        path: 'standalone/thank-you',
                        lazy: Thankyou,
                    },
                    {
                        path: 'standalone',
                        lazy: Standalone,
                        children: [
                            {
                                path: 'form-instruction',
                                lazy: StandaloneInstructions,
                            },
                            {
                                path: 'form',
                                lazy: StandaloneForm,
                            },
                            {
                                path: 'post-form-submission',
                                lazy: StandaloneSuccess,
                            },
                        ],
                    },
                    {
                        path: 'register',
                        lazy: RegisterCandidate,
                    },
                    {
                        path: 'assessment',
                        lazy: Assessment,
                        children: [
                            // Entry
                            { path: 'invite', lazy: Invite },
                            { path: 'slot-booking', lazy: AssessmentSlotBooking },
                            // Pre-checks
                            { path: 'hardware-check', lazy: HardwareTest },
                            { path: 'guide-lines', lazy: NavigationGuidelinesController },
                            // Core experience
                            {
                                path: 'playground',
                                lazy: PlayGround,
                                children: [
                                    { path: 'objective', lazy: ObjectivePlayGround },
                                    { path: 'playlist-objective', lazy: PlaylistObjectivePlayground },
                                    { path: 'async', lazy: AsyncPlayGround },
                                    { path: 'long-form', lazy: LongFormPlayground },
                                    { path: 'external', lazy: ExternalPlayground },
                                    { path: 'form', lazy: FormsPlayground },
                                    { path: 'coding', lazy: CodingPlayground },
                                ],
                            },
                            // Submission
                            { path: 'submit', lazy: AssessmentSubmission },
                            // Outcome
                            { path: 'result', lazy: Submission },
                            { path: 'feedback', lazy: Feedback },
                            { path: 'thank-you', lazy: Thankyou },
                            // Error/fallback
                            { path: 'assessment-error', lazy: AssessmentError },
                            { path: 'assessment-status-error', lazy: AssessmentStatusError },
                        ],
                    },
                    {
                        path: 'payment',
                        lazy: PaymentLayout,
                        children: [
                            {
                                path: 'details',
                                lazy: SKUDetails,
                            },
                            {
                                path: 'summary',
                                lazy: PaymentSummary,
                            },
                            {
                                path: 'completed',
                                lazy: PaymentCompletedCB,
                            },
                            {
                                path: 'invoice',
                                lazy: PaymentInvoice,
                            },
                            {
                                path: 'pending',
                                lazy: SKUDetails,
                            },
                            {
                                path: 'failed',
                                lazy: PaymentFailed,
                            },
                            {
                                path: 'transaction-report',
                                lazy: TransactionReport,
                            },
                        ],
                    },
                    {
                        path: 'drive',
                        lazy: DriveLayout,
                        children: [
                            {
                                path: 'register',
                                lazy: DriveRegister,
                            },
                            {
                                path: 'post-registration-form',
                                lazy: DrivePostRegistrationForm,
                            },
                            {
                                path: 'booking-cancel',
                                lazy: CancelBookingContainer,
                            },
                            {
                                path: 'cancel',
                                lazy: DriveCancelWindow,
                            },
                            {
                                path: 'booking-window-cancel',
                                lazy: BookingWindowCancelled,
                            },
                            {
                                path: 'booking-time-unavailable',
                                lazy: BookingTimeUnavailable,
                            },
                            {
                                path: 'lobby-waiting',
                                lazy: LobbyWaitingContainer,
                            },
                            {
                                path: 'slot-booking',
                                lazy: DriveSlotBookingContainer,
                            },
                            {
                                path: 'thank-you',
                                lazy: Thankyou,
                            },
                        ],
                    },
                    {
                        path: 'consent',
                        lazy: ConsentContainer,
                    },
                    // Legacy Scheduling Route Redirects
                    {
                        path: 'scheduling/self-scheduling',
                        lazy: OldCxRouteMap,
                    },
                    {
                        path: 'scheduling/interview-decline-form',
                        lazy: OldCxRouteMap,
                    },
                    {
                        path: 'scheduling/session-join',
                        lazy: OldCxRouteMap,
                    },
                    {
                        path: 'scheduling',
                        lazy: Scheduling,
                        children: [
                            {
                                path: 'propose-new-time-accept',
                                lazy: AcceptProposedTimeContainer,
                            },
                            {
                                path: 'confirm-interview',
                                lazy: ConfirmInterviewContainer,
                            },
                            {
                                path: 'propose-new-time',
                                lazy: ProposeNewTime,
                            },
                            {
                                path: 'propose-new-time-decline',
                                lazy: DeclineProposedTimeContainer,
                            },
                            {
                                path: 'drive-registration',
                                lazy: DriveRegister,
                            },
                            {
                                path: 'slot-booking',
                                lazy: SlotBookingContainer,
                            },
                            {
                                path: 'join-interview',
                                lazy: JoinInterview,
                            },
                            {
                                path: 'booking-confirmation',
                                lazy: BookingConfirm,
                            },
                            {
                                path: 'reschedule-booking',
                                lazy: BookingReSchedule,
                            },
                            {
                                path: 'cancellation-closed',
                                lazy: CancellationWindowClosed,
                            },
                            {
                                path: 'reschedule-closed',
                                lazy: RescheduleWindowClosed,
                            },
                            {
                                path: 'booking-closed',
                                lazy: BookingWindowClosed,
                            },
                            {
                                path: 'session-closed',
                                lazy: SessionAlreadyCompleted,
                            },
                            {
                                path: 'decline-interview',
                                lazy: InterviewDecline,
                            },
                            {
                                path: 'running-late',
                                lazy: RunningLate,
                            },
                        ],
                    },
                    {
                        path: 'biometric-authentication',
                        lazy: BiometricAuthentication,
                        children: [
                            {
                                path: 'face-auth',
                                lazy: FaceAuthContainer,
                            },
                        ],
                    },
                    {
                        path: 'certification-exam',
                        lazy: CertificationExam,
                    },
                    {
                        path: 'evaluation',
                        lazy: Evaluation,
                    },
                    {
                        path: 'language-evaluation-speaking',
                        lazy: LanguageEvaluationSpeaking,
                    },
                    {
                        path: 'combined-report',
                        lazy: CombinedEvaluation,
                    },
                    {
                        path: 'standalone-payment',
                        lazy: StandAlonePayment,
                    },
                    {
                        path: 'job-description',
                        lazy: JobDescription,
                    },
                    {
                        path: 'public-assessment',
                        lazy: PublicAssessmentLoadable,
                    },
                    {
                        path: 'share-availability',
                        lazy: CandidateAvailabilityContainer,
                    },
                ],
            },
        ],
    },
]);
export default router;
